import { createError, defineNuxtRouteMiddleware } from 'nuxt/app'

/** 路径含大写字母时统一跳转到 404 页面，query 参数不参与判断。 */
export default defineNuxtRouteMiddleware((to) => {
  if (/[A-Z]/.test(to.path)) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
})
